import {
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { styles } from "./menu.style";

const NotificationButton = ({
  handleNotificationClick,
  notifications = [],
  notificationAnchorEl,
  handleNotificationClose,
  handleNotificationSelect,
}) => {
  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleNotificationClick}
        aria-controls="notification-menu"
        aria-haspopup="true"
      >
        <Badge
          badgeContent={notifications?.filter((n) => !n.read).length || 0}
          color="error"
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        id="notification-menu"
        anchorEl={notificationAnchorEl}
        keepMounted
        open={Boolean(notificationAnchorEl)}
        onClose={handleNotificationClose}
        PaperProps={{
          sx: styles.menuPaper,
        }}
      >
        {notifications?.map((notification) => (
          <MenuItem
            key={notification.id}
            onClick={() => handleNotificationSelect(notification)}
            sx={styles.notificationMenuItem(notification.read)}
          >
            <Box sx={styles.notificationContent}>
              <Typography
                variant="body1"
                sx={styles.notificationText(notification.read)}
              >
                {notification.message}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={styles.notificationDate}
              >
                {new Date(notification.date).toLocaleString()}
              </Typography>
            </Box>
          </MenuItem>
        ))}
        {(!notifications || notifications.length === 0) && (
          <MenuItem disabled>
            <Typography>No new notifications</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default NotificationButton;
